import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { BsModalRef } from '@node_modules/ngx-bootstrap/modal';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.css']
})
export class InputDialogComponent extends AppComponentBase {

  MessageHeader: string;
  MessageTitle: string;

  userInput: string = '';

  @Output() onSubmit = new EventEmitter<string>();

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef) {
    super(injector);
  }

  submit() {
    this.onSubmit.emit(this.userInput);
    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide();
  }
}
